<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sale Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Sales Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Details",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "customerobj.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],

      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "customerobj.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "staff",
          sortable: true,
          label: "DELIVERED BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      editAmtData: {
          id: "",
          total: "",
          paid: "",
      },
      deleteData: {
          id: "",
      },
      editData: {
          id: "",
      },

      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
        totalBalance:0,
      },
      
      invoice:{
        id:''
      },
      amountError: "",
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","Sales","filterStatus"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings","ReceiptSettings"]),
    ...mapGetters("invoices", ["InvoiceId"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.Sales ? this.Sales.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Sales ? this.Sales.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    Sales(newValue){
      if(newValue){
        this.SalesData();
      }
    },
    InvoiceId(newValue) {
      if (newValue && this.ReceiptSettings.invoice_type == 1) {
        window.open(
          `https://${window.location.host}/receipts/invoice.php?id=${btoa(newValue)}`
        );
      }else if(newValue && this.ReceiptSettings.invoice_type == 2){
        this.$router.push(`/invoice_details/${btoa(newValue)}`); 
      }
    } 
  },
  methods: {
    ...mapActions({
      FetchSales: "saledetails/fetchSaleDetails",
      EditPaid: "saledetails/editAmtPaidMode",
      EditSale: "saledetails/editSale",
      DeleteSale: "saledetails/deleteSale",
      FetchCustomers: "customers/fetchCustomers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      GenerateNewInvoice:"invoices/generateInvoice"

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },    

    resetModal() {
      this.editAmtData.id = "";
      this.editAmtData.total = "";
      this.editAmtData.paid = "";
    },
    resetError(){
        this.amountError = "";
    },
    resetDelete(){
        this.deleteData.id = "";
    },
    resetEdit(){
        this.editData.id = "";
    },
    resetGenerate(){
        this.invoice.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
    },
    addCommas() {
        this.editAmtData.paid = this.thousandSeperator(this.editAmtData.paid);
    },
    ShowEdit(data) {
        this.editAmtData.id = data.id;
        this.editAmtData.total = data.totalAmt;
        this.editAmtData.paid = this.thousandSeperator(data.totalPaid);
    },
    showInvoiceModal(data) {
      this.invoice.id = data.item.id;
    },
    editAmt(modalId){
        this.modal_id = modalId;
        if(this.editAmtData.paid==""){
            this.amountError = "Amount Paid is required";
            return
        }
        else{
            this.amountError = "";
        }
        this.EditPaid(this.editAmtData).then(() => {
          this.FetchSales(this.data);
        });
    },
    editSale(modalId){
        this.modal_id = modalId;
        this.EditSale(this.editData).then(() => {
          this.FetchSales(this.data);
        });
    },
    deleteSale(modalId){
        this.modal_id = modalId;
        this.DeleteSale(this.deleteData).then(() => {
          this.FetchSales(this.data);
        });
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    SalesData(){
      if(this.Sales){
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Sales.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totalAmt);
        total_paid = total_paid+parseInt(item.totalPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
      }
    },

    filterReport(){
      this.FetchSales(this.data);
    },
    Receipt_print(Id){
      if(this.ReceiptSettings.receipt_type == 1){
          window.open(
            `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
          );
      }else if(this.ReceiptSettings.receipt_type == 2){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv2.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 3){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv3.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 4){
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv4.php?id=${btoa(Id)}`
        );
      }else if(this.ReceiptSettings.receipt_type == 5){
          window.open(
            `https://${window.location.host}/receipts/deliverynote.php?id=${btoa(Id)}`
          );
      }else{
        window.open(
          `https://${window.location.host}/receipts/receipt.php?id=${btoa(Id)}`
        );
      }
    },

    GenerateInvoice(modal){
      this.GenerateNewInvoice(this.invoice.id);  
      this.closeModal(modal);   
    }
    
  },
  created() {  
    this.FetchSales(atob(this.$route.params.id));
    this.FetchGeneralSettings();
    this.FetchCustomers();
    this.FetchBranches();
    this.fetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-3"></div>              
              <div class="col-md-6">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
              <div class="col-md-3" align="right">
                  <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-arrow-left"></i> Back</b-button>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="Sales?Sales:[]"
                  :fields="GeneralSettings.capture_delivery_staff == 1?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(amt_paid)="data">
                  <span class="text-warning" 
                  v-b-modal.expired-modal
                    @click="ShowEdit(data.item)" v-if="data.item.numpaid<2">
                    {{ thousandSeperator(data.item.totalPaid) }}
                    </span>
                    <span v-else>
                    {{ thousandSeperator(data.item.totalPaid) }}
                    </span>
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-dropdown text="More Actions..." size="sm" class="btn-primary" v-if="MyUserPerm.modify_sales == 1">
                        <b-dropdown-item 
                        v-if="MyUserPerm.delete_sales == 1"
                        v-b-modal.delete-purchase-modal
                    @click="showDeleteModal(data)">
                    <i class="fa fa-trash text-danger"></i> <span class="text-danger"> Delete</span> 
                    </b-dropdown-item>
                      <b-dropdown-item
                      v-if="MyUserPerm.edit_sales == 1"
                      v-b-modal.edit-purchase-modal
                      @click="showEditModal(data)"
                      ><i class="fa fa-edit text-primary"></i> <span class="text-primary"> Edit</span>
                      </b-dropdown-item>                     
                      <b-dropdown-item variant="info" @click="Receipt_print(data.item.id)"><i class="fa fa-file-excel"></i> Reprint</b-dropdown-item>
                      <b-dropdown-item
                      v-if="data.item.totalAmt>data.item.totalPaid"
                      v-b-modal.generate-invoice-modal
                      @click="showInvoiceModal(data)"
                      ><i class="fa fa-file-invoice text-success"></i> <span class="text-success"> New Invoice</span>
                      </b-dropdown-item>
                    </b-dropdown>
                    </div>
                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.product }}</td>
                      <td>{{ det.qty }}{{ det.usymbol }}</td>
                      <td>{{ det.SPrice?thousandSeperator(det.SPrice):0 }}</td>
                      <td>{{ det.SPrice?thousandSeperator(det.SPrice*det.qty):0 }}</td>
                      <!-- <td>{{ det.batch }}</td>
                      <td>{{ det.expiry }}</td> -->
                    </tr>
                    </tbody>
                  </table>
                </template>               
              </b-table>
              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{thousandSeperator(totals.totalPaid)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{thousandSeperator(totals.totalDiscount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{thousandSeperator(totals.totalBalance)}}</span></h5>
                  </div>
              </div>
            </div>
            <Loader  v-if="!Sales"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">Edit Amount Paid For a Sale of {{ thousandSeperator(editAmtData.total) }}</h4></template
      >
        <label>Amount Paid</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="editAmtData.paid"
            placeholder="Enter actual amount"
            @input="resetError(),addCommas()"
          />
        </div>
        <div class="text-danger" v-if="amountError">
          <em>{{ amountError }}</em>
        </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-warning" @click="editAmt('expired-modal')">
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
              header-bg-variant="warning"
              header-text-variant="light"
              body-text-variant="warning"
              footer-bg-variant="warning"
              footer-text-variant="warning"
              id="edit-purchase-modal"
              hide-footer
              @hidden="resetEdit"
            >
              <template #modal-title> Edit This Sale</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Sale? Click Proceed Button to Return Sale for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('edit-purchase-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editSale('edit-purchase-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-purchase-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to delete this Purchase? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-purchase-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteSale('delete-purchase-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Invoice modal starts -->
    <b-modal
              header-bg-variant="success"
              header-text-variant="light"
              body-text-variant="success"
              footer-bg-variant="success"
              footer-text-variant="success"
              id="generate-invoice-modal"
              hide-footer
              @hidden="resetGenerate"
            >
              <template #modal-title> Generate invoice</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Click Proceed Button to generate an invoice for this sale.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('generate-invoice-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="GenerateInvoice('generate-invoice-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
    </b-modal>
    <!-- Invoice modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
